import { styled } from "styled-components";

import { UIButton } from "common/components";
import { breakpoints } from "common/styles";
import { useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { isRtl } from "domains/language/isRtl";
import { getSiteLanguage } from "domains/language/selectors";

const StyledPageNotFound = styled.div<{ isCurrentLanguageRtl: boolean }>`
  display: flex;
  flex-flow: column;
  gap: 0.5rem;
  padding: 4rem 2rem;
  direction: ${({ isCurrentLanguageRtl }) => (isCurrentLanguageRtl ? "rtl" : "ltr")};
`;

const StyledTag = styled.div`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textFade};
  font-weight: bold;
  line-height: 1.63;
`;

const StyledHeader = styled.h1`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.textBright};
  margin: 0 0 1rem;

  @media ${breakpoints.medium} {
    max-width: 500px;
  }
`;

export const PageNotFound = () => {
  const go = useGo();
  const siteLanguage = useSelector(getSiteLanguage);
  const translate = useTranslate();

  return (
    <StyledPageNotFound isCurrentLanguageRtl={isRtl(siteLanguage)}>
      <StyledTag>{translate("app.page_not_found.tag")}</StyledTag>
      <StyledHeader>{translate("app.page_not_found.header")}</StyledHeader>
      <UIButton variant="filled" onClick={() => go("/")}>
        {translate("app.page_not_found.link")}
      </UIButton>
    </StyledPageNotFound>
  );
};
